import _APP_STORE_IOS_ICON from '../../public/images/icons/app-store-ios.svg'
import _APP_STORE_ICON from '../../public/images/icons/app-store.svg'
import _BRAND_CHECKMARK_ICON from '../../public/images/icons/brand-checkmark.svg'
import _BRAND_SELECTED_CALENDAR_ICON from '../../public/images/icons/brand-selected-calendar.svg'
import _BRAND_SELECTED_CLOCK_ICON from '../../public/images/icons/brand-selected-clock.svg'
import _BRAND_SELECTED_FILTER_ICON from '../../public/images/icons/brand-selected-filter.svg'
import _BRAND_SELECTED_LEVEL_ICON from '../../public/images/icons/brand-selected-level.svg'
import _BRAND_SELECTED_LOCATION_ICON from '../../public/images/icons/brand-selected-location.svg'
import _CALENDAR_ICON from '../../public/images/icons/calendar.svg'
import _CAMP_ICON from '../../public/images/icons/camp.svg'
import _CHECKMARK_ICON from '../../public/images/icons/checkmark.svg'
import _CHEVRON_DOWN_ICON from '../../public/images/icons/chevron-down.svg'
import _CLASS_ICON from '../../public/images/icons/class.svg'
import _TRAINING_ICON from '../../public/images/icons/class.svg'
import _CLOCK_ICON from '../../public/images/icons/clock.svg'
import _CLOSE_ICON from '../../public/images/icons/close.svg'
import _MY_CORPORATE_BENEFITS_ICON from '../../public/images/icons/corporate-benefits.svg'
import _COURSE_ICON from '../../public/images/icons/course.svg'
import _EDUCATION_ICON from '../../public/images/icons/education.svg'
import _EMPTY_STAR_ICON from '../../public/images/icons/empty-star.svg'
import _EVENT_ICON from '../../public/images/icons/event.svg'
import _FACEBOOK_ICON from '../../public/images/icons/facebook.svg'
import _FAVICON from '../../public/images/icons/favicon.ico'
import _FILLED_STAR_ICON from '../../public/images/icons/filled-star.svg'
import _FILTER_ICON from '../../public/images/icons/filter.svg'
import _FOR_BUSINESSES_ICON from '../../public/images/icons/for-businesses.svg'
import _FOR_CORPORATES_ICON from '../../public/images/icons/for-corporates.svg'
import _FRIENDS_ICON from '../../public/images/icons/friends.svg'
import _HALF_STAR_ICON from '../../public/images/icons/half-star.svg'
import _HOME_ICON from '../../public/images/icons/home.svg'
import _HORIZONTAL_LOGO from '../../public/images/icons/HorizontalLogo.svg'
import _INSTAGRAM_ICON from '../../public/images/icons/instagram.svg'
import _INVERTED_HORIZONTAL_LOGO from '../../public/images/icons/InvertedHorizontalLogo.svg'
import _KLARNA_ICON from '../../public/images/icons/klarna.svg'
import _LEFT_ARROW_DARK_ICON from '../../public/images/icons/left-arrow-dark.svg'
import _ADVANCED_LEVELS_ICON from '../../public/images/icons/level-advanced.svg'
import _ALL_LEVELS_ICON from '../../public/images/icons/level-all.svg'
import _BEGINNER_LEVELS_ICON from '../../public/images/icons/level-beginner.svg'
import _INTERMEDIATE_LEVELS_ICON from '../../public/images/icons/level-intermediate.svg'
import _LEVEL_ICON from '../../public/images/icons/level.svg'
import _LIVESTREAM_ICON from '../../public/images/icons/live-stream.svg'
import _LOCATION_ICON from '../../public/images/icons/location.svg'
import _MAP_ICON from '../../public/images/icons/map.svg'
import _MASTERCARD_ICON from '../../public/images/icons/mastercard.svg'
import _MENU_ICON from '../../public/images/icons/menu.svg'
import _MY_BOOKINGS_ICON from '../../public/images/icons/my-bookings.svg'
import _MY_FAVORITES_ICON from '../../public/images/icons/my-favorites.svg'
import _MY_PASSES_ICON from '../../public/images/icons/my-passes.svg'
import _MY_PAYMENT_METHODS_ICON from '../../public/images/icons/my-payment-methods.svg'
import _MY_PERSONAL_INFORMATION_ICON from '../../public/images/icons/my-personal-information.svg'
import _MY_PROFILE_ICON from '../../public/images/icons/my-profile.svg'
import _MY_VIDEOS_ICON from '../../public/images/icons/my-videos.svg'
import _OPEN_TRAINING_ICON from '../../public/images/icons/open-training.svg'
import _PAYPAL_ICON from '../../public/images/icons/paypal.svg'
import _PLAY_STORE_ICON from '../../public/images/icons/play-store.svg'
import _PUBLIC_MATCH_ICON from '../../public/images/icons/public-match.svg'
import _QUARTER_STAR_ICON from '../../public/images/icons/quarter-star.svg'
import _RECOMMENDATIONS_ICON from '../../public/images/icons/recommendations.svg'
import _RETREAT_ICON from '../../public/images/icons/retreat.svg'
import _RIGHT_ARROW_DARK_ICON from '../../public/images/icons/right-arrow-dark.svg'
import _RIGHT_ARROW_ICON from '../../public/images/icons/right-arrow.svg'
import _SEARCH_ICON from '../../public/images/icons/search.svg'
import _SIGNOUT_ICON from '../../public/images/icons/signout.svg'
import _TERTIARY_FIRE_ICON from '../../public/images/icons/tertiary-fire.svg'
import _THREE_QUARTER_STAR_ICON from '../../public/images/icons/three-quarter-star.svg'
import _VIDEO_ICON from '../../public/images/icons/video.svg'
import _VISA_ICON from '../../public/images/icons/visa.svg'
import _WORKSHOP_ICON from '../../public/images/icons/workshop.svg'
import _YOUTUBE_ICON from '../../public/images/icons/youtube.svg'

export const ALL_LEVELS_ICON = _ALL_LEVELS_ICON
export const BEGINNER_LEVELS_ICON = _BEGINNER_LEVELS_ICON
export const BRAND_SELECTED_CALENDAR_ICON = _BRAND_SELECTED_CALENDAR_ICON
export const BRAND_CHECKMARK_ICON = _BRAND_CHECKMARK_ICON
export const BRAND_SELECTED_CLOCK_ICON = _BRAND_SELECTED_CLOCK_ICON
export const BRAND_SELECTED_FILTER_ICON = _BRAND_SELECTED_FILTER_ICON
export const BRAND_SELECTED_LEVEL_ICON = _BRAND_SELECTED_LEVEL_ICON
export const BRAND_SELECTED_LOCATION_ICON = _BRAND_SELECTED_LOCATION_ICON
export const INTERMEDIATE_LEVELS_ICON = _INTERMEDIATE_LEVELS_ICON
export const ADVANCED_LEVELS_ICON = _ADVANCED_LEVELS_ICON
export const APP_STORE_IOS_ICON = _APP_STORE_IOS_ICON
export const APP_STORE_ICON = _APP_STORE_ICON
export const CALENDAR_ICON = _CALENDAR_ICON
export const CLOCK_ICON = _CLOCK_ICON
export const CAMP_ICON = _CAMP_ICON
export const CHECKMARK_ICON = _CHECKMARK_ICON
export const CHEVRON_DOWN_ICON = _CHEVRON_DOWN_ICON
export const CLASS_ICON = _CLASS_ICON
export const CLOSE_ICON = _CLOSE_ICON
export const COURSE_ICON = _COURSE_ICON
export const EMPTY_STAR_ICON = _EMPTY_STAR_ICON
export const EDUCATION_ICON = _EDUCATION_ICON
export const EVENT_ICON = _EVENT_ICON
export const FACEBOOK_ICON = _FACEBOOK_ICON
export const FILTER_ICON = _FILTER_ICON
export const FILLED_STAR_ICON = _FILLED_STAR_ICON
export const FOR_CORPORATES_ICON = _FOR_CORPORATES_ICON
export const FOR_BUSINESSES_ICON = _FOR_BUSINESSES_ICON
export const FRIENDS_ICON = _FRIENDS_ICON
export const HALF_STAR_ICON = _HALF_STAR_ICON
export const HOME_ICON = _HOME_ICON
export const HORIZONTAL_LOGO = _HORIZONTAL_LOGO
export const INSTAGRAM_ICON = _INSTAGRAM_ICON
export const INVERTED_HORIZONTAL_LOGO = _INVERTED_HORIZONTAL_LOGO
export const KLARNA_ICON = _KLARNA_ICON
export const LEVEL_ICON = _LEVEL_ICON
export const LOCATION_ICON = _LOCATION_ICON
export const LIVESTREAM_ICON = _LIVESTREAM_ICON
export const MAP_ICON = _MAP_ICON
export const MASTERCARD_ICON = _MASTERCARD_ICON
export const MENU_ICON = _MENU_ICON
export const MY_BOOKINGS_ICON = _MY_BOOKINGS_ICON
export const MY_CORPORATE_BENEFITS_ICON = _MY_CORPORATE_BENEFITS_ICON
export const MY_FAVORITES_ICON = _MY_FAVORITES_ICON
export const MY_PASSES_ICON = _MY_PASSES_ICON
export const MY_PAYMENT_METHODS_ICON = _MY_PAYMENT_METHODS_ICON
export const MY_PERSONAL_INFORMATION_ICON = _MY_PERSONAL_INFORMATION_ICON
export const MY_PROFILE_ICON = _MY_PROFILE_ICON
export const MY_VIDEOS_ICON = _MY_VIDEOS_ICON
export const OPEN_TRAINING_ICON = _OPEN_TRAINING_ICON
export const PAYPAL_ICON = _PAYPAL_ICON
export const PLAY_STORE_ICON = _PLAY_STORE_ICON
export const PUBLIC_MATCH_ICON = _PUBLIC_MATCH_ICON
export const QUARTER_STAR_ICON = _QUARTER_STAR_ICON
export const RECOMMENDATIONS_ICON = _RECOMMENDATIONS_ICON
export const RETREAT_ICON = _RETREAT_ICON
export const LEFT_ARROW_DARK_ICON = _LEFT_ARROW_DARK_ICON
export const RIGHT_ARROW_DARK_ICON = _RIGHT_ARROW_DARK_ICON
export const RIGHT_ARROW_ICON = _RIGHT_ARROW_ICON
export const SEARCH_ICON = _SEARCH_ICON
export const SIGNOUT_ICON = _SIGNOUT_ICON
export const TRAINING_ICON = _TRAINING_ICON
export const TERTIARY_FIRE_ICON = _TERTIARY_FIRE_ICON
export const THREE_QUARTER_STAR_ICON = _THREE_QUARTER_STAR_ICON
export const WORKSHOP_ICON = _WORKSHOP_ICON
export const VISA_ICON = _VISA_ICON
export const VIDEO_ICON = _VIDEO_ICON
export const YOUTUBE_ICON = _YOUTUBE_ICON
export const FAVICON = _FAVICON
